/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1NotificationMobileAppQueryResponse,
  GetApiV1NotificationMobileAppQueryParams,
  GetApiV1NotificationMobileApp401,
  GetApiV1NotificationMobileApp500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileApp.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1NotificationMobileApp } from "../../clients/notificationMobileAppController/getApiV1NotificationMobileApp.ts";

export const getApiV1NotificationMobileAppQueryKey = (
  params?: GetApiV1NotificationMobileAppQueryParams,
) =>
  [
    { url: "/api/v1/notification/mobile-app" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1NotificationMobileAppQueryKey = ReturnType<
  typeof getApiV1NotificationMobileAppQueryKey
>;

export function getApiV1NotificationMobileAppQueryOptions(
  params?: GetApiV1NotificationMobileAppQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1NotificationMobileAppQueryKey(params);
  return queryOptions<
    GetApiV1NotificationMobileAppQueryResponse,
    ResponseErrorConfig<
      GetApiV1NotificationMobileApp401 | GetApiV1NotificationMobileApp500
    >,
    GetApiV1NotificationMobileAppQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1NotificationMobileApp(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Suporta filtros por tipo de template, criado por, período de agendamento e busca por texto (título, tipo de template, código ou nome da turma). **(Requer Authorization para autenticação)**
 * @summary Retorna a grid paginada de notificações (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app}
 */
export function useGetApiV1NotificationMobileApp<
  TData = GetApiV1NotificationMobileAppQueryResponse,
  TQueryData = GetApiV1NotificationMobileAppQueryResponse,
  TQueryKey extends QueryKey = GetApiV1NotificationMobileAppQueryKey,
>(
  params?: GetApiV1NotificationMobileAppQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1NotificationMobileAppQueryResponse,
        ResponseErrorConfig<
          GetApiV1NotificationMobileApp401 | GetApiV1NotificationMobileApp500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1NotificationMobileAppQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1NotificationMobileAppQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1NotificationMobileApp401 | GetApiV1NotificationMobileApp500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
